


const state = {
    currentPage: 1, 
    lastPage: 100
};

const getters = {
    visiblePages: (state) => {
        const current = state.currentPage;
        const total = state.lastPage;
        const CHUNK_SIZE = 10; // Fixed size for First and Last chunks (1-10)
        const MIDDLE_WINDOW_SIZE = 10; // Fixed size for the sliding middle window
        const pages = [];

        // If the total number of pages is small, just show all.
        if (total <= CHUNK_SIZE * 3 + 2) { 
            for (let i = 1; i <= total; i++) {
                pages.push(i);
            }
            return pages;
        }

        // --- Core Definitions ---
        const halfWindow = Math.floor(MIDDLE_WINDOW_SIZE / 2);
        const globalCenterPage = Math.floor(total / 2); 
        
        // Define the pages that are NOT in the fixed chunks
        const minMiddleStartBoundary = CHUNK_SIZE + 1; // Page 11
        const maxMiddleEndBoundary = total - CHUNK_SIZE; // Page 19990
        
        // Define the size of the buffer zone where the middle window will anchor to the center
        const bufferZone = CHUNK_SIZE + halfWindow + 1; // e.g., Page 16

        // --- 1. Determine the Middle Window Start/End ---
        let middleStart, middleEnd;

        if (current <= bufferZone || current >= total - bufferZone + 1) {
            // Zone 1 & 3 (Start or End Zone): Anchor the middle window to the Global Center.
            middleStart = globalCenterPage - halfWindow;
            middleEnd = middleStart + MIDDLE_WINDOW_SIZE - 1;

        } else {
            // Zone 2 (Middle Zone): Sliding window centered on the current page.
            middleStart = current - halfWindow;
            middleEnd = current + (MIDDLE_WINDOW_SIZE - halfWindow - 1);
        }

        // --- 2. Boundary Correction (Enforcing min/max limits) ---

        // Ensure the window respects the maximum boundary (19990)
        if (middleEnd > maxMiddleEndBoundary) {
            middleEnd = maxMiddleEndBoundary;
            middleStart = middleEnd - MIDDLE_WINDOW_SIZE + 1;
        }

        // Ensure the window respects the minimum boundary (11)
        if (middleStart < minMiddleStartBoundary) {
            middleStart = minMiddleStartBoundary;
            middleEnd = middleStart + MIDDLE_WINDOW_SIZE - 1;
        }

        // --- 3. Build the Pages Array ---
        
        // A. Add First Chunk (Pages 1 to 10)
        for (let i = 1; i <= CHUNK_SIZE; i++) {
            pages.push(i);
        }

        // B. Add Left Ellipsis and Middle Window
        if (middleStart > CHUNK_SIZE) {
            if (middleStart > CHUNK_SIZE + 1) {
                 pages.push('...');
            }
            
            for (let i = middleStart; i <= middleEnd; i++) {
                if (i > CHUNK_SIZE) { 
                    pages.push(i);
                }
            }
        }

        // C. Add Right Ellipsis and Last Chunk (Pages 19991 to 20000)
        const lastChunkStart = total - CHUNK_SIZE + 1;

        if (middleEnd < lastChunkStart) {
            if (middleEnd < lastChunkStart - 1) {
                pages.push('...');
            }
            
            for (let i = lastChunkStart; i <= total; i++) {
                if (i > middleEnd) { 
                    pages.push(i);
                }
            }
        }

        return pages;
    }
};

const mutations = {
    SET_PAGINATION_META(state, meta) {
        state.currentPage = meta.current_page; 
        state.lastPage = meta.last_page;
},
};

const actions = {
    async fetchNewPageData({ commit }, meta) {
        try {      
        commit('SET_PAGINATION_META', meta);
        } catch (error) {
        console.error("Error fetching data:", error);
        } finally {
            
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}